export default function Velmour() {
  const card: React.CSSProperties = {
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '18px 22px',
    marginBottom: 18,
  };
  const h: React.CSSProperties = { margin: '0 0 6px' };
  const wordmark: React.CSSProperties = {
    margin: 0,
    fontSize: 'clamp(3rem, 13vw, 7.5rem)',
    fontWeight: 800,
    letterSpacing: '0.06em',
    lineHeight: 1,
    color: 'var(--text)',
  };
  const tagline: React.CSSProperties = {
    margin: '10px 0 0',
    fontSize: 14,
    letterSpacing: '0.42em',
    textTransform: 'uppercase',
    color: 'var(--text-muted)',
  };
  const hero: React.CSSProperties = {
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 10,
    padding: '56px 22px 48px',
    marginBottom: 18,
    textAlign: 'center',
  };
  const linkRow: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    margin: '12px 0 0',
  };
  const chip: React.CSSProperties = {
    border: '1px solid var(--border-strong)',
    borderRadius: 999,
    padding: '6px 14px',
    fontSize: 14,
    color: 'var(--text-muted)',
    background: 'var(--bg-subtle)',
  };
  const tip: React.CSSProperties = {
    background: 'var(--bg-subtle)',
    borderLeft: '3px solid var(--accent)',
    padding: '8px 12px',
    borderRadius: 6,
    margin: '10px 0 0',
    fontSize: 14,
    color: 'var(--text-muted)',
  };

  return (
    <div style={{ maxWidth: 760, lineHeight: 1.6 }}>
      <div style={hero}>
        <h1 style={wordmark}>VELMOUR</h1>
        <p style={tagline}>music</p>
      </div>

      <div style={card}>
        <h3 style={h}>🎧 Слушать</h3>
        <p style={{ margin: '4px 0 0', color: 'var(--text-muted)' }}>
          Площадки, на которых выходят релизы.
        </p>
        <div style={linkRow}>
          <span style={chip}>Spotify</span>
          <span style={chip}>Apple Music</span>
          <span style={chip}>YouTube Music</span>
          <span style={chip}>Яндекс Музыка</span>
        </div>
        <p style={tip}>💡 Заглушка — ссылки пока не проставлены. Пришлите адреса, и я их подключу.</p>
      </div>

      <div style={card}>
        <h3 style={h}>✉️ Связаться</h3>
        <p style={{ margin: '4px 0 0', color: 'var(--text-muted)' }}>
          По вопросам сотрудничества и релизов.
        </p>
        <div style={linkRow}>
          <span style={chip}>velmourmusic.com</span>
          <span style={chip}>Instagram</span>
          <span style={chip}>Telegram</span>
        </div>
      </div>
    </div>
  );
}
